import { useCallback, useMemo } from 'react'
import { useFormik } from 'formik'
import { useDispatch, useSelector } from 'react-redux'

import Form from '../../../../../../components/Form'
import SroiFormContent from '../../components/SroiFormContent'

import { usePurifiedFormik } from '../../../../../../hooks/formHooks/usePurifiedFormik'
import { transformValuesToBE } from './formatters'

import {
  clearCreateSroiReportPayload,
  createSroiReportPayload
} from '../../../../../../modules/actions/socialReturnOnInvestment'
import {
  createSroiReportPayloadErrorSelector,
  createSroiReportPayloadIsLoadingSelector,
  createSroiReportPayloadWasCreatedSelector,
  getSroiInputsPresetSelector
} from '../../../../../../modules/selectors/socialReturnOnInvestment'
import { selectedPartnershipSelector } from '../../../../../../modules/selectors/partnerships'

import { SROI_REPORT_PAYLOAD_CREATE } from '../../../../../../constants/forms'
import { getInitialValues, validationSchema } from './fields'
import { STAKEHOLDERS_LIST } from '../../stakeholdersFields'
import { COUNTRY_ID } from '../../fields'

function SroiReportPayloadCreateForm() {
  const dispatch = useDispatch()

  const wasCreated = useSelector(createSroiReportPayloadWasCreatedSelector)
  const sroiInputsPreset = useSelector(getSroiInputsPresetSelector)

  const selectedPartnership = useSelector(selectedPartnershipSelector)
  const { id: partnershipId } = selectedPartnership

  const stakeholderSectionInputsPreset = useMemo(() => {
    return sroiInputsPreset?.inputs_preset?.[STAKEHOLDERS_LIST]?.[0]
  }, [sroiInputsPreset])

  const initialValues = useMemo(
    () => getInitialValues(sroiInputsPreset?.inputs_preset?.[COUNTRY_ID]),
    [sroiInputsPreset]
  )

  const onSubmit = useCallback(
    values => {
      const formattedValues = transformValuesToBE(values, selectedPartnership)

      dispatch(
        createSroiReportPayload({
          ...formattedValues,
          partnership: partnershipId
        })
      )
    },
    [dispatch, partnershipId, selectedPartnership]
  )

  const clearHandler = useCallback(() => dispatch(clearCreateSroiReportPayload()), [dispatch])

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit
  })
  const purifiedFormik = usePurifiedFormik(formik)

  return (
    <Form
      formName={SROI_REPORT_PAYLOAD_CREATE}
      formik={purifiedFormik}
      successSubmit={wasCreated}
      errorSelector={createSroiReportPayloadErrorSelector}
      isLoadingSelector={createSroiReportPayloadIsLoadingSelector}
      clearHandler={clearHandler}
    >
      <SroiFormContent formik={formik} stakeholderSectionInputsPreset={stakeholderSectionInputsPreset} />
    </Form>
  )
}

export default SroiReportPayloadCreateForm
